import { useCallback, useContext } from 'react';

import {
  OTC_TRADER_TABS,
  OTCTraderContext,
  TAB_PREFIX,
} from '../../../providers/otc-trader/otc-trader-provider';
import { QuickPricerProvider } from '../../../providers/otc-trader/quick-pricer-provider';
import { SurfaceMarkingProvider } from '../../../providers/otc-trader/surface-marking-provider';
import SurfaceMarking from '../surface-marking';

import { OTCTraderTabsBase } from './otc-trader-tabs-base';

import { PricingProvider } from '../../../providers/pricing-provider';
import Pricing from '../../pricing';
import './styles.scss';

export const OTCTraderTabs = () => {
  const { currentTab, tabs } = useContext(OTCTraderContext);

  const renderTab = useCallback((tab: string) => {
    if (tab.startsWith(TAB_PREFIX)) {
      return (
        <QuickPricerProvider tab={tab}>
          <SurfaceMarkingProvider tab={tab}>
            <SurfaceMarking tab={tab} />
          </SurfaceMarkingProvider>
        </QuickPricerProvider>
      );
    } else if (tab === OTC_TRADER_TABS.SURFACE_MARKING) {
      return (
        <QuickPricerProvider tab="surface-marking">
          <SurfaceMarkingProvider tab="surface-marking">
            <SurfaceMarking tab="surface-marking" />
          </SurfaceMarkingProvider>
        </QuickPricerProvider>
      );
    } else if (tab === OTC_TRADER_TABS.PRICER) {
      return (
        <PricingProvider>
          <Pricing />
        </PricingProvider>
      );
    }
  }, []);

  const renderTabs = () => {
    return tabs.map((tab) => {
      const isCurrentTab = currentTab === tab.key;

      return (
        <div key={tab.key} className={`tab-wrapper ${isCurrentTab && 'visible'}`}>
          {renderTab(tab.key)}
        </div>
      );
    });
  };

  return (
    <div className="otc-trader-container">
      <OTCTraderTabsBase />
      {renderTabs()}
    </div>
  );
};
